import React from "react";
import Logo from "./Logo.js";
import ContactForm from "../components/ContactForm.js";

export default function Info() {
  return (
    <div className="bg-white text-black min-h-screen px-6 py-10 sm:px-10">
      <Logo />
      <div className="mt-16 flex flex-col gap-16 md:mt-36">
        <div className="mx-auto flex w-full max-w-2xl flex-col gap-16">
          <h1 className="w-full text-lg font-bold uppercase">
            Altrove è un luogo dove il sociale incontra la cultura. In questo
            spazio convivono idee, eventi, performance e convivialità. Nato per
            riscoprire il valore delle relazioni umane.
          </h1>
          <div className="w-full">
            <ContactForm></ContactForm>
          </div>
        </div>
      </div>
    </div>
  );
}
